import { createContext, useContext } from "react";

interface SelectedContextProps {
  selected: number;
  setSelected: (value: number) => void;
}

export const SelectedContext = createContext<SelectedContextProps>({
  selected: 0,
  setSelected: () => null,
});

export const SelectedContextProvider = SelectedContext.Provider;

export const useSelectedContext = (): SelectedContextProps =>
  useContext(SelectedContext);
